// extracted by mini-css-extract-plugin
module.exports = {"block":"_16940","item":"_9688"};